<template>
  <a-modal title="Estado del proceso"
           v-model="visible"
           width="80%"
           style="top: 20px;"
           @cancel="closeModal"
           :closable="!loading"
           :maskClosable="!loading">
    <a-spin :spinning="loading">
      <a-descriptions bordered :title="'Detalles del proceso # ' + selectedExecution.id" size="small">
        <a-descriptions-item label="Estado">
          <a-tag :color="statusColor">
            {{selectedExecution.exec_status}}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="Descripción">
          {{selectedExecution.description}}
        </a-descriptions-item>
        <a-descriptions-item label="F. Inicio">
          {{selectedExecution.start_date}}
        </a-descriptions-item>
        <a-descriptions-item label="F. Fin">
          {{selectedExecution.end_date}}
        </a-descriptions-item>
        <a-descriptions-item label="Creado Por">
          {{selectedExecution.created_by}}
        </a-descriptions-item>
        <a-descriptions-item label="Creado En">
          {{selectedExecution.created_on}}
        </a-descriptions-item>
        <a-descriptions-item label="Archivo Subido">
          <a-button type="link" @click="downloadFile">
            <a-icon type="download"></a-icon>
            {{selectedExecution.file_name}}
          </a-button>
        </a-descriptions-item>
        <a-descriptions-item label="Log Ejecucion">
          {{selectedExecution.log.split('#')[0]}}
        </a-descriptions-item>
      </a-descriptions>

      <a-tabs defaultActiveKey="1">
        <a-tab-pane key="1" tab="Logs">
          <g-datatable :columns="masterSetup.columns"
                       :endpoint="masterSetup.endpoint"
                       :tableConfig="masterSetup.tableConfig"
                       :customSlots="masterSetup.customSlots"
                       :requestData="masterRequestData"
          >
            <span slot="estadoRenderer" slot-scope="{text}">
              <a-tag v-if="text === 'FALLIDO'" color="red">
                {{text}}
              </a-tag>
              <a-tag v-if="text === 'FINALIZADO'" color="green">
                {{text}}
              </a-tag>
            </span>
          </g-datatable>
        </a-tab-pane>
        <a-tab-pane key="2" tab="Parámetros">
          <a-list size="small" bordered :data-source="selectedExecution.params">
            <a-list-item slot="renderItem" slot-scope="item, index">
              <span style="font-weight: bold">{{item.label}}</span> {{item.value}}
            </a-list-item>
          </a-list>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
    <template slot="footer">
      <span></span>
      <a-button type="danger" @click="ejecutarAccion('REVERT')" :loading="loading" v-if="puedeRevertir">
        {{selectedExecution.revert_process_label||'Revertir'}}
      </a-button>
      <a-button type="danger" @click="ejecutarAccion('CANCEL')" :loading="loading" v-if="puedeCancelar">
        {{selectedExecution.cancel_process_label||'Cancelar'}}
      </a-button>
      <a-button type="primary" @click="ejecutarAccion('FINISH')" :loading="loading" v-if="puedeFinalizar"
                style="background-color: #0ea432;border-color: #0ea432">
        {{selectedExecution.post_process_label||'Finalizar'}}
      </a-button>
    </template>
  </a-modal>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    props: ['ejecucion'],
    data () {
      return {
        loading: false,
        error: false,
        selectedExecution: {},
        visible: false,
        puedeReintentar: false,
        puedeRevertir: false,
        puedeCancelar: false,
        puedeFinalizar: false,
        masterSetup: {
          endpoint: 'dynamic_load_exec_logs',
          columns: [
            {title: '#', dataIndex: 'id', sorter: true},
            {title: 'Num. Linea Procesada', dataIndex: 'line', sorter: true},
            {title: 'Log Linea Procesada', dataIndex: 'log', sorter: true},
            {
              title: 'Estado',
              dataIndex: 'estado_exec_linea',
              sorter: true,
              scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'estadoRenderer'
              }
            }
          ],
          tableConfig: {
            rowKey: 'id'
          },
          customSlots: ['estadoRenderer']
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      showModal (executionId) {
        this.visible = true
        this.loading = true
        this.error = false
        this.updateDetails(executionId)
      },
      updateDetails (executionId) {
        this.httpClient.getInstance().get(`dynamic_loads/get_execution_details/${executionId}`).then((response) => {
          this.selectedExecution = response.data
          this.updateFlags()
        }).catch(() => {
          this.error = true
        }).then(() => {
          this.loading = false
        })
      },
      downloadFile () {
        if (this.loading) return
        this.loading = true

        this.httpClient.getInstance().post('dynamic_loads/descarga_archivo_subido', {
          exec_id: this.selectedExecution.id
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', this.selectedExecution.file_name)
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          this.loading = false
        })
      },
      ejecutarAccion (action) {
        if (this.loading) return

        let self = this
        this.$confirm({
          title: 'Confirmación',
          content: '¿Está seguro que desea continuar?',
          onOk () {
            return new Promise((resolve, reject) => {
              self.loading = true

              self.httpClient.getInstance().post('dynamic_loads/ejecutar_accion_cargue', {
                exec_id: self.selectedExecution.id,
                action: action
              }).then(() => {
                Mensajes.success('Correcto', 'Acción ejecutada correctamente')
                resolve && resolve()
              }).catch((error) => {
                Mensajes.error('Error', 'No fue posible descargar el archivo.')
                reject && reject(error)
              }).then(() => {
                self.updateDetails(self.selectedExecution.id)
              })
            })
          },
          onCancel () {}
        })
      },
      closeModal () {
        this.visible = false
      },
      updateFlags () {
        this.puedeReintentar = false
        this.puedeRevertir = false
        this.puedeCancelar = false
        this.puedeFinalizar = false

        switch (this.selectedExecution.exec_status) {
          // case 'PROGRAMADO':
          //   break
          // case 'EN EJECUCION':
          //   break
          case 'CORRECTO':
            this.puedeCancelar = this.selectedExecution.cancelarDisponible
            this.puedeFinalizar = this.selectedExecution.finalizarDisponible
            break
          case 'FINALIZADO':
            this.puedeRevertir = this.selectedExecution.reversarDisponible
            break
          case 'FALLIDO':
          case 'REVERSADO':
          case 'CANCELADO':
            this.puedeReintentar = true
            break
        }
      }
    },
    computed: {
      statusColor () {
        switch (this.selectedExecution.exec_status) {
          // case 'PROGRAMADO':
          //   break
          // case 'EN EJECUCION':
          //  break
          case 'FINALIZADO':
            return 'green'
          case 'FALLIDO':
          case 'REVERSADO':
          case 'CANCELADO':
            return 'red'
          case 'CORRECTO':
            return 'blue'
        }
        return ''
      },
      masterRequestData () {
        return {dynamic_load_exec_id: this.selectedExecution.id}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/DynamicLoads/DynamicLoadStatusModal.vue